// Default sound effects for the game
const SOUND_BASE_URL = 'https://teacherwilliam.sgp1.digitaloceanspaces.com';

// Helper function to resolve sound URLs
const resolveSoundUrl = (path: string): string => {
  // If path is already a full URL, return it as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // Otherwise prepend the base URL
  return `${SOUND_BASE_URL}${path}`;
};

export const defaultSounds: Record<string, string> = {
  // UI sounds
  'ui.button': resolveSoundUrl('/sounds/ui/button-click.mp3'),
  'ui.toggle': resolveSoundUrl('/sounds/ui/toggle-switch.mp3'),
  'ui.notification': resolveSoundUrl('/sounds/ui/notification.mp3'),
  'ui.success': resolveSoundUrl('/sounds/ui/success.mp3'),
  'ui.error': resolveSoundUrl('/sounds/ui/error.mp3'),
  'ui.shuffle': resolveSoundUrl('/sounds/ui/shuffle.mp3'),
  
  // Gameplay sounds
  'gameplay.cardSelect': resolveSoundUrl('/sounds/gameplay/card-select.mp3'),
  'gameplay.cardPlace': resolveSoundUrl('/sounds/gameplay/card-place.mp3'),
  'gameplay.cardFlip': resolveSoundUrl('/sounds/gameplay/card-flip.mp3'),
  'gameplay.cardDeal': resolveSoundUrl('/sounds/gameplay/card-deal.mp3'),
  'gameplay.roundStart': resolveSoundUrl('/sounds/gameplay/round-start.mp3'),
  'gameplay.roundEnd': resolveSoundUrl('/sounds/gameplay/round-end.mp3'),
  'gameplay.turnChange': resolveSoundUrl('/sounds/gameplay/turn-change.mp3'),
  
  // Win sounds
  'win.game': resolveSoundUrl('/sounds/win/game-win.mp3'),
  'win.round': resolveSoundUrl('/sounds/win/round-win.mp3'),
  'win.tournament': resolveSoundUrl('/sounds/win/tournament-win.mp3'),
  'win.achievement': resolveSoundUrl('/sounds/win/achievement-unlock.mp3'),
  
  // Lose sounds
  'lose.game': resolveSoundUrl('/sounds/lose/game-lose.mp3'),
  'lose.round': resolveSoundUrl('/sounds/lose/round-lose.mp3'),
  'lose.tournament': resolveSoundUrl('/sounds/lose/tournament-lose.mp3')
};

// Display names for sound events in the UI
export const soundDisplayNames: Record<string, string> = {
  // UI sounds
  'ui.button': 'Button Click',
  'ui.toggle': 'Toggle Switch',
  'ui.notification': 'Notification',
  'ui.success': 'Success Message',
  'ui.error': 'Error Message',
  'ui.shuffle': 'Card Shuffle',
  
  // Gameplay sounds
  'gameplay.cardSelect': 'Card Select',
  'gameplay.cardPlace': 'Card Placement',
  'gameplay.cardFlip': 'Card Flip',
  'gameplay.cardDeal': 'Card Deal',
  'gameplay.roundStart': 'Round Start',
  'gameplay.roundEnd': 'Round End',
  'gameplay.turnChange': 'Turn Change',
  
  // Win sounds
  'win.game': 'Game Win',
  'win.round': 'Round Win',
  'win.tournament': 'Tournament Win',
  'win.achievement': 'Achievement Unlock',
  
  // Lose sounds
  'lose.game': 'Game Loss',
  'lose.round': 'Round Loss',
  'lose.tournament': 'Tournament Loss'
};